import { BaseTranslation } from 'src/i18n/i18n-types';
import {
  AssetListViewMode,
  AssetSortOption,
} from 'src/pages/Assets/routes/AssetList/consts';

const viewModes: Record<AssetListViewMode, string> = {
  gallery: 'Gallery',
  table: 'Table',
};

const assetSortOptions: Record<AssetSortOption, string> = {
  fileName: 'A-Z',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  type: 'Type',
};

export const assets: BaseTranslation = {
  allAssets: 'All Assets',
  briefAssets: 'Brief Assets',
  collections: 'Collections',
  upload: 'Upload',
  emptyTitle: 'Nothing to see here',
  empty: {
    title: 'Manage assets with ease',
    description:
      'Manage your assets with status updates, timeline commenting and custom tags or share collections.',
    actionLabel: 'Add Content',
  },
  errors: {
    listAssets: "Something went wrong and we couldn't retreive your assets.",
  },
  uploader: 'Uploader',
  searchPlaceholder: 'Search assets by text or transcript...',
  multiSelect: {
    numSelected: '{count} asset{{count:s}} selected',
    addTags: 'Add tags to assets',
    addTagsConfirm: 'Add tags to {count} asset{{count:s}}',
    addTagsSuccess: 'Added tags to {count} asset{{count:s}}',
    addTagsError:
      "Something went wrong and we weren't able to tag your assets: {error}",
  },
  deleteAssets: {
    title: 'Delete assets',
    body: 'Are you sure you want to delete these assets?',
    success: 'Assets were deleted successfully',
    error: 'Error deleting assets: {error}',
  },
  addToCollectionError:
    "We couldn't add this asset to the collection. We will look into this. The error received was: {error}",
  addToCollection: 'Add to collection',
  added: 'Added',
  numAssets: '{count} assets',
  table: {
    name: 'Name',
    size: 'Size',
    dateCreated: 'Date Created',
    dateModified: 'Date Modified',
    resolution: 'Resolution',
    type: 'Type',
  },
  viewModes,
  assetSortOptions,
};
